import type { FaireProductEntity } from "../../entity_types/product";

export const p_cht2yd2x74: FaireProductEntity = {
  token: "p_cht2yd2x74",
  type: "product",
  name: "BR-RS-HEART Heart Rhinestone Bracelet - White",
  brandToken: "b_h6l667zq",
  brandName: "Girlie Girl Originals",
  imageUrl: "https://cdn.faire.com/fastly/1cec8d3c8a6a02a5a0ee5f586ddbe7cbe26936bf2e6d51622f7a8e6e5cee6f9c.jpeg",
  galleryImageUrls: [],
  priceDollars: 7.5,
  description: "Whether it’s for function or style, hair clips are a fun accessory for everyday use. Check out our variety of colors and sizes! \n",
  tags: [],
  msrpDollars: 15,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:01:56.946Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
